import IconDatabase from 'images/icons/database.svg';
import IconFileText from 'images/icons/file-text.svg';
import IconStar from 'images/icons/star.svg';
import { ApiModel } from 'lib/interfaces/api';

export type DataSourceType =
  | ApiModel.ExternalIntegrationDataSourceCsv
  | ApiModel.ExternalIntegrationDataSourceGoogleSheets
  | ApiModel.ExternalIntegrationDataSourceMysql
  | ApiModel.ExternalIntegrationDataSourceSnowflake
  | ApiModel.ExternalIntegrationDataSourceRedshift;

export const RelationalDataSource = [
  ApiModel.ExternalIntegrationDataSourceMysql,
  ApiModel.ExternalIntegrationDataSourceRedshift,
];

export const DATA_SOURCE_TYPES = {
  [ApiModel.ExternalIntegrationDataSourceCsv]: 'CSV',
  [ApiModel.ExternalIntegrationDataSourceGoogleSheets]: 'Google Sheets',
  [ApiModel.ExternalIntegrationDataSourceMysql]: 'MySQL',
  [ApiModel.ExternalIntegrationDataSourceSnowflake]: 'Snowflake',
  [ApiModel.ExternalIntegrationDataSourceRedshift]: 'Redshift',
  [ApiModel.ExternalIntegrationDataSourceS3]: 'S3',
};

export const DATA_SOURCE_ICONS = {
  [ApiModel.ExternalIntegrationDataSourceCsv]: IconFileText,
  [ApiModel.ExternalIntegrationDataSourceGoogleSheets]: IconFileText,
  [ApiModel.ExternalIntegrationDataSourceMysql]: IconDatabase,
  [ApiModel.ExternalIntegrationDataSourceSnowflake]: IconStar,
  [ApiModel.ExternalIntegrationDataSourceRedshift]: IconDatabase,
  // TODO (bjon): think of a unique icon for this?
  [ApiModel.ExternalIntegrationDataSourceS3]: IconFileText,
};
